import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import { vesselTypeValidationSchema } from '../../validation/vesselType';
import VesselTypeForm from '~/components/vesselTypeForm/vesselTypeForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getVesselTypeQuery = gql`
  query vesselType($id: Int!) {
    vesselType(id: $id) {
      id
      name
      description
      quantity
      volume
      variants {
        id
        name
        productId
      }
    }
  }
`;

export const updateVesselTypesutation = gql`
  mutation updateVesselType($id: Int!, $name: String!, $description: String, $volume: Float!, $quantity: Int!) {
    updateVesselType(id: $id, name: $name, description: $description, volume: $volume, quantity: $quantity) {
      id
      name
      breweryId
      description
      volume
      quantity
    }
  }
`;

export class VesselTypeEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same silly update Apollo issue I keep running into
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;

    return (
      <Query query={getVesselTypeQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { vesselType } = data;
          return (
            <div className="content">
              <Mutation mutation={updateVesselTypesutation}>
                {(updateIngredient, { error }) => (
                  <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={vesselType}
                    validationSchema={vesselTypeValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateIngredient({
                          variables: {
                            id,
                            ...values
                          }
                        });
                        history.push(`/settings/vesseltypes/${id}?updated=true`);
                      } catch (err) {
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={VesselTypeForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(VesselTypeEdit));



// WEBPACK FOOTER //
// ./src/containers/vesselTypeEdit/vesselTypeEdit.jsx